import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class DoubleImage {
  constructor(el) {
    this.el = el
    this.leftImg = el.querySelector('.double-image--left-img img')
    this.rightImg = el.querySelector('.double-image--right-img img')
    this.init()
  }

  init() {
    if (this.leftImg) this.parallax(this.leftImg, 70)
    if (this.rightImg) this.parallax(this.rightImg, 50)
  }

  parallax(target, amount) {
    gsap.set(target, { y: 15 })
    gsap.to(target, {
      y: -15,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: target,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      },
    })
  }
}
